import { alias } from '@ember/object/computed';
import { computed } from '@ember/object';
import MoneyNegatorProxy from '@square/dashboard-money/utils/money-negator-proxy';
import ReturnLineItem from '@square/dashboard-data/models/squareup/beemo/api/v2/models/return-line-item';
import Amounts from '@square/dashboard-data/models/squareup/beemo/api/v2/models/amounts';
import { ProtoBaseModel, attr, repeated } from '@square/dashboard-data/utils/ember-model-stubs';
export default ProtoBaseModel.extend({
  returnLineItem: repeated(ReturnLineItem),
  returnLineItems: alias('returnLineItem'),
  returnAmounts: attr(Amounts),
  negatedReturnAmounts: computed('returnAmounts', function () {
    return MoneyNegatorProxy.create({
      toNegate: this.returnAmounts
    });
  })
});